import { CalendarDays, ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/shared/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'
import { PERIOD_OPTIONS } from '@/shared/constants/dashboardPeriod'

/**
 * Reusable period filter dropdown for dashboards and pages.
 * Supports All Time, Today, This Week, This Month, etc.
 * Features open/close chevron toggle (ChevronUp / ChevronDown).
 */
function DashboardPeriodFilter({ value, onChange }) {
  const [open, setOpen] = useState(false)
  const selected =
    PERIOD_OPTIONS.find((opt) => opt.value === value) || PERIOD_OPTIONS[0]

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className="h-10 gap-2 rounded-full border border-slate-200 bg-white px-4 text-xs font-semibold text-slate-700 shadow-sm hover:bg-slate-50 focus:border-slate-400"
        >
          <CalendarDays className="size-3.5 text-slate-500" />
          <span>{selected.label}</span>
          {open ? (
            <ChevronUp size={14} className="text-slate-400" />
          ) : (
            <ChevronDown size={14} className="text-slate-400" />
          )}
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="end"
        className="w-52 rounded-2xl p-1.5 shadow-xl"
      >
        {PERIOD_OPTIONS.map((opt) => {
          const isSelected = opt.value === value
          return (
            <DropdownMenuItem
              key={opt.value}
              onSelect={() => onChange?.(opt.value)}
              className={`cursor-pointer rounded-xl px-3 py-2 text-xs font-medium ${
                isSelected
                  ? 'bg-indigo-50 font-semibold text-indigo-600'
                  : 'text-slate-700'
              }`}
            >
              {opt.label}
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default DashboardPeriodFilter
